// Intake-logs portal — constants & small pure helpers.

import { InvocationStatus, LogsRole } from './types';

// ---------- Firestore collections ----------
export const DB_LOG_INVOCATIONS = 'intake_log_invocations';
export const DB_LOGS_SYNC = 'intake_logs_sync';
export const DB_LOGS_CONFIG = 'intake_logs_config';
export const DB_LOGS_AUDIT = 'intake_logs_audit';
export const LOGS_CONFIG_DOC = 'config';

// ---------- Callable Cloud Function names ----------
export const FN_GET_INTAKE_LOG_EVENTS = 'getIntakeLogEvents';
export const FN_SET_LOGS_ROLE = 'setLogsRole';
export const FN_SYNC_INTAKE_LOGS_NOW = 'syncIntakeLogsNow';

// ---------- Retention ----------
// Parsed rows live 14 days (confirmed spec). Because the retention window and
// the maximum browse range are the same, the loaded working set IS the full
// queryable history — client-side filtering over it is complete (up to the
// cap), so there's no separate "global search" layer like recordings needs.
export const LOGS_RETENTION_DAYS = 14;
export const LOGS_RETENTION_MS = LOGS_RETENTION_DAYS * 24 * 60 * 60 * 1000;

// ---------- Roles ----------
export const LOGS_ROLE_LABELS: Record<LogsRole, string> = {
  viewer: 'Viewer',
  admin: 'Admin',
};

// Most access first — used by role pickers.
export const LOGS_ROLE_ORDER: LogsRole[] = ['admin', 'viewer'];

// ---------- Statuses ----------
export const STATUS_LABELS: Record<InvocationStatus, string> = {
  success: 'Success',
  fail: 'Fail',
  skipped: 'Skipped',
};

// ---------- List sizing ----------
// The page loads a bounded working set (range-scoped, newest first) and
// filters it in memory; "Load older" pages past the cap with a cursor.
export const LOGS_WORKING_SET_CAP = 1000;

// ---------- Display helpers ----------

export function fmtWhen(ms: number | null | undefined): string {
  try {
    return ms ? new Date(ms).toLocaleString() : '—';
  } catch {
    return '—';
  }
}

export function fmtDuration(ms: number | null | undefined): string {
  if (ms == null) return '—';
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(1)} s`;
}

// Missing status = the parser saw no definitive signal (e.g. the submit
// router, which just forwards and never writes a METADATA line).
export function statusLabel(s: string | null | undefined): string {
  if (s === 'success' || s === 'fail' || s === 'skipped') return STATUS_LABELS[s];
  return 'Unknown';
}
